import { render } from "./AboutS14.vue?vue&type=template&id=7b65cb45&scoped=true"
import script from "./AboutS14.vue?vue&type=script&lang=js"
export * from "./AboutS14.vue?vue&type=script&lang=js"

import "./AboutS14.vue?vue&type=style&index=0&id=7b65cb45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b65cb45"]])

export default __exports__